import apiClient from '../apiClient';
import { GET_PAYMENT_METHOD_LIST } from '../apiUrl';

const getPaymentMethodApi = () => {
  return apiClient.get(GET_PAYMENT_METHOD_LIST);
};

export default getPaymentMethodApi;
